import React from "react";
import logo from "./logoz-removebg-preview.png";
import inc from "./ci.png";
import inc2 from "./d.png";
import { Link } from "react-router-dom";
import { feadata } from "../Feautured/FeaData";
import "../Main.css"

const Footer = () => {
  return (
    <footer id="footer" className="footer light-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-3 col-md-5 footer-about">
            <a href="" className="logo d-flex align-items-center">
              <span className="sitename">
                <img src={logo} alt="" />
              </span>
            </a>
            <div className="footer-contact pt-3">
              <p>
                17 Morris road, Newtongrange <br /> Dalkeith
                <br /> EH22 4ST
              </p>
              {/* <p>New York, NY 535022</p> */}
              <p className="mt-3">
                <strong>Phone:</strong>{" "}
                <span>
                  {" "}
                  +44 07802416170,
                  <br />
                  +44 01316771557
                </span>
              </p>
              <p>
                <strong>Email:</strong> <span>info@jrcareltd.com</span>
              </p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="https://x.com/jrcareltd">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a href="https://www.facebook.com/share/1BUzZpZJxS/">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://www.instagram.com/jrcare_scotland?igsh=MWozbHRmeXRvMzljbA%3D%3D&utm_source=qr">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/jrcareltd">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              {/* Map first half of feadata */}
              {feadata
                .slice(0, Math.ceil(feadata.length / 2))
                .map((service) => (
                  <React.Fragment key={service._id}>
                    {/* Main service link */}
                    <li>
                      <Link to={`/service/${service._id}`}>
                        {service.title}
                      </Link>
                    </li>
                  </React.Fragment>
                ))}
              <li>
                {/* <Link to="">
                  <a href="#">Case Studies</a>
                </Link> */}
              </li>
            </ul>
            <ul>
              {/* Map second half of feadata */}
              {feadata.slice(Math.ceil(feadata.length / 2)).map((service) => (
                <React.Fragment key={service._id}>
                  {/* Main service link */}
                  <li>
                    <Link to={`/service/${service._id}`}>{service.title}</Link>
                  </li>
                </React.Fragment>
              ))}

              <li>
                <Link to="/career">
                  <a href="#">Careers</a>
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-3 footer-links">
            <h4>Legal</h4>
            <ul>
              <li>
                <Link to="/privacy">
                  <a href="#">Privacy Policy</a>
                </Link>
              </li>
              <li>
                <Link to="/cookies">
                  <a href="#">Cookies Policy</a>
                </Link>
              </li>
              <li>
                <Link to="/term">
                  <a href="#">Terms and Conditions</a>
                </Link>
              </li>
              <li>
                {/* <Link to="/genderpay">
                  <a href="#">Gender Pay Update - 2024</a>
                </Link> */}
              </li>
              {/* <li>
                <Link to="/ModernSlavery">
                  <a href="#">Modern Slavery Statement</a>
                </Link>
              </li> */}

              {/* <li>
                <Link to="/duty2021">
                  <a href="#">Duty of Candour Annual report 2020-2021</a>
                </Link>
              </li>
              <li>
                <Link to="/duty2022">
                  <a href="#">Duty of Candour Annual report 2022-2023</a>
                </Link>
              </li>
              <li>
                <Link to="/duty2023">
                  <a href="#">Duty of Candour Annual report 2023-2024</a>
                </Link>
              </li> */}
            </ul>
          </div>

          <div className="col-lg-3 col-md-3 gap-1 footer-links">
            {/* <h4>ci</h4> */}
            <img className="img1" src={inc} alt=""  />
            <img className="img2" src={inc2} alt=""  />
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">jrcareltd.com</strong>{" "}
          <span>All Rights Reserved</span>
        </p>
        <div className="credits">
          {/* You can add any credits here if needed */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
